<template>
  <div class="mt-4 grid gap-4" v-auto-animate>
    <div class="space-y-3" v-if="fixtures?.length">
      <!-- <div class="font-bold">{{ $t('shared.nav.fixtures') }}</div> -->
      <PartialsGames :games="fixtures" />
    </div>
    <div class="space-y-3" v-if="results?.length">
      <div class="font-bold">{{ $t('shared.nav.results') }}</div>
      <PartialsGames :games="results" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'league'
})

const route = useRoute()

const { data } = await useFetch(`/api/v1/leagues/${route.params?.league}/games`, { 
  key: `league-games-${route.params?.league}`,
  baseURL: useEnv('apiBase'),
})

const now = useDate()
const oneWeekAhead = now.add(7, 'day')

// 1. Fixtures: Games from the last 7 days (based on first game date)
const fixtures = computed(() => {
  const upcomingGames = data.value?.games?.filter(g => !now.isAfter(g.startDate)) || []
  const upcomingDate = upcomingGames[0]?.startDate
  const weekBeforeLatest = useDate(upcomingDate).add(6, 'day')

  return upcomingGames
    ?.filter(g => weekBeforeLatest.isAfter(g.startDate))
})

// 2. Results: Games from the last 7 days (based on last game date)
const results = computed(() => {
  const pastGames = (data.value?.games?.filter(g => now.isAfter(g.startDate)) || [])?.reverse()
  const latestDate = pastGames[0]?.startDate
  const weekBeforeLatest = useDate(latestDate).subtract(6, 'day')

  return pastGames
    ?.filter(g => useDate(g.startDate).isSameOrAfter(weekBeforeLatest))
})
</script>